<div class="header" style="margin-left: 6px" data-cy="confirmation-dialog-title">
  <h3 mat-dialog-title>{{ data.title | translate }}</h3>
</div>
<mat-dialog-content>
  <div class="flex-row align-items-center overflow-hidden">
    <div style="flex: 1 1 auto; margin-left: 6px">
      {{ data.text | translate }}
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="custom-dialog-actions justify-content-around">
  <button
    mat-dialog-close
    data-cy="dialog-button-accept"
    class="btn m-2 flex-grow-1 btn-primary"
    (click)="dialogRef.close({ dismissed: false })"
  >
    {{ data.buttonText | translate | uppercase }}
  </button>

  <button
    mat-dialog-close
    data-cy="dialog-button-close"
    class="btn m-2 flex-grow-1 btn-outline-primary"
    (click)="dialogRef.close({ dismissed: true })"
  >
    {{ 'button.close' | translate }}
  </button>
</mat-dialog-actions>
